"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconEdit = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconEdit = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M5.232 18.754h1.262l9.736-9.737-1.261-1.236-9.737 9.736v1.237Zm-2.15 2.15v-4.285l14.85-14.888 4.333 4.294L7.367 20.904H3.082ZM15.613 8.397l-.644-.616 1.261 1.236-.617-.62Z"
}));
exports.IconEdit = IconEdit;
//# sourceMappingURL=IconEdit.js.map